import {computed, Injectable, signal} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GameModalService {
  private confirmSubject = new Subject<boolean>();
  private _isOpen = signal(false);

  isOpen = computed(() => this._isOpen());

  open(): Observable<boolean> {
    this._isOpen.set(true);
    return this.confirmSubject.asObservable();
  }

  confirm() {
    this._isOpen.set(false);
    this.confirmSubject.next(true);
  }

  cancel() {
    this._isOpen.set(false);
    this.confirmSubject.next(false);
  }

  close() {
    this._isOpen.set(false);
  }
}
